import React from 'react';

// Shared section head: eyebrow with a single vermilion intervention square,
// plus the section index at the editorial margin.
export default function SectionHead({ eyebrow, index, tone = 'light', className = '' }) {
  const dark = tone === 'dark';
  return (
    <div className={`flex items-center justify-between gap-6 ${className}`}>
      <div className="flex items-center gap-3">
        <span className="inline-block h-2 w-2 bg-vermilion" aria-hidden="true" />
        <span className={`eyebrow ${dark ? 'text-bone/70' : 'text-midnight/70'}`}>{eyebrow}</span>
      </div>
      {index && <span className={`eyebrow ${dark ? 'text-steel-light' : 'text-steel-dark'}`}>{index}</span>}
    </div>
  );
}
